import {Component, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {CommonModule} from '@angular/common';
import {ModalModule} from 'ngx-bootstrap';
import {PromptBodyComponent} from './Component/PromptBodyComponent';
import {PromptCancelComponent} from './Component/PromptCancelComponent';
import {PromptComponent} from './Component/PromptComponent';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {PromptConfirmComponent} from './Component/PromptConfirmComponent';
import {PromptFooterComponent} from './Component/PromptFooterComponent';
import {PromptHeaderComponent} from './Component/PromptHeaderComponent';
import {PromptModalComponent} from './Component/PromptModalComponent';
export class NgPromptModule {

static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    declarations: [
        PromptComponent,
        PromptHeaderComponent,
        PromptBodyComponent,
        PromptConfirmComponent,
        PromptCancelComponent,
        PromptModalComponent,
        PromptFooterComponent
    ],
    imports     : [
        BrowserModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ModalModule.forRoot()
    ],
    exports     : [
        PromptComponent,
        PromptHeaderComponent,
        PromptBodyComponent,
        PromptConfirmComponent,
        PromptCancelComponent,
        PromptModalComponent,
        PromptFooterComponent
    ],
    providers   : [],
    bootstrap   : []

}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function NgPromptModule_tsickle_Closure_declarations() {
/** @type {?} */
NgPromptModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
NgPromptModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
